<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5>Logs de acceso</h5>
			<p-table
				#dt1
				sortField="datetime_unix" 
				[sortOrder]="-1"
				[value]="usersLogs"
				dataKey="id"
				[rows]="20"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="[
					'name',
					'surname',
					'email',
					'datetime_string'
				]"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button
								pButton
								pRipple
								label="Actualizar"
								pTooltip="Actualizar"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadUsersLogs(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<tr>
						<th class="text-center" pSortableColumn="datetime_unix">
							<p-sortIcon field="datetime_unix"></p-sortIcon>
							Último acceso
						</th>
						<th class="text-center" pSortableColumn="name">
							<p-sortIcon field="name"></p-sortIcon>Cuenta
						</th>
						<th class="text-center" pSortableColumn="email">
							<p-sortIcon field="email"></p-sortIcon>
							Email
						</th>
						<th></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-user>
					<tr>
						<td class="text-center" style="min-width: 5rem">
							{{ user.datetime_string }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ user.role_id == 4 ? user.name : user.name +' '+ user.surname  }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ user.email }}
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando logs de acceso...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>